rjm.ui.ChartBuilderSeriesPerspectiveView = rjm.ui.ChartBuilderBlockableView.extend(
  events:
    "click .dropdown-menu li a": "changePerspective"

  initialize: (options) ->
    if not options or not options.chartModel
      throw "InvalidConstructorArgs - ChartBuilderSeriesPerspectiveView"

    _.bindAll this, "changePerspective", "generateTemplateData", "unblock", "block", "render", "listenToCohortField"
    @chartModel = options.chartModel

    @listenTo @chartModel.getCurrentSeries(), "change:restrictionSet change:trend", =>
      @render()
      @unblock()
    @listenTo @chartModel.getCurrentSeries().get("categorySet"), "add:categorySelectors remove:categorySelectors", @render
    @listenTo @chartModel, "change:isTimeOnXAxis change:timeFrame", @render
    @listenTo @chartModel, "change:api_conn_id", @block
    
    if @chartModel.getCurrentSeries().get("cohortDescriptor")?
      @listenToCohortField()

    @listenTo @chartModel.getCurrentSeries(), "change:cohortDescriptor", (series, options) =>
      if series.get("cohortDescriptor")?
        @listenToCohortField()
      else if series.previous("cohortDescriptor")?
        @stopListening series.previous("cohortDescriptor")
      @render()

    return

  listenToCohortField: () ->
    @listenTo @chartModel.getCurrentSeries().get("cohortDescriptor"), "change:cohortField", @render

  changePerspective: (e) ->
    newPerspective = $(e.target).parent().data('value')
    @chartModel.getCurrentSeries().set 
      dataPerspective: rjm.app.enums.dataPerspective[newPerspective]
    @render()

  generateTemplateData: ->
    dataperspectiveEnums: @chartModel.getValidPerspectives()
    propertyName: "names"
    selectedPerspective: @chartModel.getCurrentSeries().get("dataPerspective").serializedValue
    selectedPerspectiveName: @chartModel.getCurrentSeries().get("dataPerspective").names

  render: ->
    $(@el).html ich["chartBuilderSeries.perspective"](@generateTemplateData())

    return @
)
